import { useContext } from 'react';
import { useHistory } from 'react-router-dom';
import _get from 'lodash/get';
import queryString from 'query-string';

import { UserDetailsContext } from 'context/userDetails';

const useTournamentDetails = () => {
	const history = useHistory();
	const { selectedUser } = useContext(UserDetailsContext);
	const searchString = _get(history, ['location', 'search']);
	const searchParams = queryString.parse(searchString);
	const {
		ltid,
		mttid,
		cgrid,
		gameName,
		playingAttempt,
		gameType,
		pwfInviteId
	}: {
		ltid?: number | null;
		mttid?: number | null;
		cgrid?: number | null;
		gameName?: string | null;
		playingAttempt?: number | null;
		gameType?: string | null;
		pwfInviteId?: string | null;
	} = searchParams;

	return { ltid, mttid, cgrid, gameName, selectedUser, playingAttempt, gameType, pwfInviteId };
};

export default useTournamentDetails;
